import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useTranslation } from 'react-i18next'

export const Chatbot: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('chatbot') || 'Chatbot'}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className='text-muted-foreground'>{t('chatbot_coming_soon') || 'Chatbot feature coming soon...'}</p>
      </CardContent>
    </Card>
  )
}
